import { loginSettingsStateModel } from './stateModels';

export function loginSettings(state = loginSettingsStateModel, action) {
    switch (action.type) {
        default:
            return state
    }
}